<template>
  <div class="pagination" v-if="total">
    <el-pagination
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      :current-page="pageInfo.pageNum"
      :page-size="pageInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      :page-sizes="[5, 10, 20, 30, 50, 100]"
    >
    </el-pagination>
    <!-- layout="total, prev, pager, next, jumper" -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageInfo: {
        pageSize: 100,
        pageNum: 1,
      },
    };
  },
  props: {
    pageSize: {
      type:Number,
      require: true,
    },
    total: {
      type:Number,
      require: true,
    },
  },
  mounted() {
    this.pageInfo.pageSize = this.pageSize;
  },
  methods: {
    handleCurrentChange(newPage) {
      // 切换页数传值
      this.$emit('currentPageNumChange',newPage);
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.$emit('handleSizeChange',val);
    },
  },
};
</script>

<style scoped lang="scss">
@import "./pagination.scss";
</style>